export default "__VITE_ASSET__CojkGeBL__"